

const MAIN_TITLE = "ESports"

const TAG_LINE ="Experience the Adrenaline Rush of Esports."

const TAG_LINE2="The only BOundaries for you are those you place in yourself"
const THEME = {
    main:"rgb(8, 2, 53)",
    highlight:"#9c1bd3",
    primary:"#FFE77D",
    secondary:"white",
    
}

const BUTTON ={
  backgroundColor:"#9c1bd3",
  fontColor:"#ffe77d",
}

const ESPORTS_TEAM =[
    {
      imgUrl:"https://gamingonphone.com/wp-content/uploads/2020/10/WhatsApp-Image-2020-10-18-at-11.03.31-PM.jpeg",
             title:"Total gaming"  ,
             description:" Esports events in Free Fire has ended with team Total Gaming Esports being crowned as the Free Fire Pro League Summer (FFPL) 2021 champions.",
             followLinks:[
              'https://www.instagram.com/totalgaming_official/'
             ]
    },
    {
      imgUrl:"https://playerbros.com/wp-content/uploads/2020/03/EShGJKrWsAA5jyT.jpg",
             title:" BL4ZE Esports"  ,
             description:"Blaze Esports PUBG'de Emin Adımlarla İlerliyor",
             followLinks:[
              'https://www.instagram.com/officialblazeesports/'
             ]
    },
    {
      imgUrl:"https://th.bing.com/th/id/OIP.-escVL_9k8c5kbsBQGDRLwHaEK?rs=1&pid=ImgDetMain",
      title:"Team Vitality"  ,
       description:"they were crowned champions of COD Mobile India Challenge S2 when they vanquished tournament favourites GodLike Esports 4-2. ",
       followLinks:[
        'https://www.instagram.com/teamvitality/'
       ]
    },
    {
      imgUrl:"https://th.bing.com/th/id/OIP.gf3TIICHn_WjIe8h_6UotAHaE8?rs=1&pid=ImgDetMain",
             title:"Team brutality"  ,
             description:"Team Brutality is an Indian Counter-Strike: Global Offensive team. Over the course of their history, Team Brutality has featured numerous players, occasionally using stand-ins due many of their players being part-time.",
             followLinks:[
              'https://www.instagram.com/teambrutality/'
             ]
    }]
    
    export {ESPORTS_TEAM,MAIN_TITLE , TAG_LINE ,THEME ,TAG_LINE2,BUTTON }



